import { BackButton } from "@/components/custom/BackButton"
import { PageTitle } from "@/components/custom/PageTitle"
import { RootState } from "@/redux"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { UserRole } from "@/constants/users/userRole"
import { TCSApplications } from "@/components/custom/AvailableTCSApplications/TCSApplications"

export const SelectSource = () => {
  const navigate = useNavigate()
  const { userData } = useSelector((state: RootState) => state.user)
  const { applications } = useSelector((state: RootState) => state.application)

  useEffect(() => {
    if (userData?.role === UserRole.USER) {
      navigate('/credentials')
    }
  }, [userData, navigate])

  return (
    <div className="protectedPageLayout">
      <BackButton buttonLink="/credentials" buttonText="Back to Credentials" />
      <PageTitle title="Add New Credential" />
      <TCSApplications applications={applications} navigatePath="/credentials/create" />
    </div>
  )
}
